import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import Loading from "./Loading";
import DriverDB from "./DriverDB";
import Nav from "./Nav";
import { useNavigate } from "react-router-dom";
import {
  thisYear,
  getFormattedDate,
  isUpcoming,
  shouldShowThumb,
  dateTime,
} from "../utils/utils";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const fetchWithRetry = async (url, retries = 6, delayTime = 3000) => {
  let attempt = 0;
  while (attempt < retries) {
    try {
      const response = await fetch(url);
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(`Error: ${response.status}`);
      }
    } catch (error) {
      if (attempt < retries - 1) {
        attempt++;
        await new Promise((resolve) => setTimeout(resolve, delayTime));
      } else {
      }
    }
  }
};

const ResultsDriver = () => {
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [sdata, setData] = useState([]);
  const { driver = "alonso" } = useParams();
  let drvgivenName = "";
  let drvfamilyName = "";

  const fetchAllData = useCallback(async () => {
    const limit = 100;
    let offset = 0;
    let allData = [];
    let hasMoreData = true;

    while (hasMoreData) {
      const url = `${BASE_URL}/drivers/${driver}/results.json?limit=${limit}&offset=${offset}`;
      // const response = await fetch(url);
      // const data = await response.json();
      // const races = data["MRData"].RaceTable.Races;
      const data = await fetchWithRetry(url);
      const races = data["MRData"].RaceTable.Races;

      if (races.length > 0) {
        allData = allData.concat(races);
        offset += limit;
      } else {
        hasMoreData = false;
      }
    }

    return allData;
  }, [driver]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const raceData = await fetchAllData();
        const sprintResponse = await fetch(
          `${BASE_URL}/drivers/${driver}/sprint.json`
        );
        const sprintData = await sprintResponse.json();

        setIsLoaded(true);
        setData(raceData.concat(sprintData["MRData"].RaceTable.Races));
      } catch (error) {
        setIsLoaded(true);
        console.error(error);
      }
    };

    fetchData();
  }, [driver, fetchAllData]);

  if (sdata[0]?.Results) {
    drvgivenName = sdata[0]?.Results[0]?.Driver.givenName;
    drvfamilyName = sdata[0]?.Results[0]?.Driver.familyName;
  } else {
    drvgivenName = sdata[0]?.SprintResults[0]?.Driver.givenName;
    drvfamilyName = sdata[0]?.SprintResults[0]?.Driver.familyName;
  }

  if (!isLoaded) {
    return <Loading />;
  } else {
    const groupedData = sdata.reduce((acc, item) => {
      const season = item.season;
      if (!acc[season]) {
        acc[season] = [];
      }
      acc[season].push(item);
      return acc;
    }, {});

    const sortedSeasons = Object.keys(groupedData).sort((a, b) => b - a);

    return (
      <div className="bg-black container-fluid p-0">
        <Nav />

        <div className="container-fluid text-center p-0 text-light mt-1">
          <h4 className="">
            <span className="text-info-emphasis px-1 bg-info fw-bold">
              {drvgivenName}
            </span>
            <span className="text-warning-emphasis px-1 bg-warning fw-bold text-uppercase">
              {drvfamilyName}
            </span>
          </h4>
          <DriverDB drv={`${drvgivenName} ${drvfamilyName}`} />
        </div>

        {sortedSeasons.map((season) => (
          <div className="pt-1">
            <h4 className="text-center text-primary m-0">
              <span className="bg-black fw-bold px-2 bg-gradient">
                Season {season}
              </span>
            </h4>
            <div className="table-responsive-sm">
              <div key={season}>
                <table className="myTable mb-1 table table-dark table-striped table-bordered border-dark">
                  <thead>
                    <tr className="">
                      <th className="text-center text-secondary bg-body-secondary">
                        R
                      </th>
                      <th className="bg-dark-subtle text-dark">GRAND PRIX</th>
                      <th className="text-center text-info bg-info-subtle">
                        P
                      </th>
                      <th className="text-center bg-secondary text-secondary-emphasis">
                        G
                      </th>
                      <th className="text-center bg-primary text-primary-emphasis">
                        L
                      </th>
                      <th className="text-end pe-1 bg-warning text-warning-emphasis p-0">
                        TIME
                      </th>
                      <th className="text-center bg-danger-subtle text-danger-emphasis p-0">
                        STATUS
                      </th>
                      <th className="text-center bg-light text-light-emphasis">
                        PT
                      </th>
                      <th className="bg-danger text-center text-danger-emphasis">
                        <span className="">FASTEST LAP</span>
                      </th>
                      <th className="text-center bg-success text-success-emphasis">
                        TEAM
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupedData[season]
                      .sort((a, b) => (a.date < b.date ? 1 : -1))
                      .map((item, index) => {
                        const results =
                          item.Results || item.SprintResults || [];
                        return (
                          <tr key={index} className="text-danger align-middle">
                            <td className="text-center text-secondary p-0">
                              {item.round}
                            </td>
                            <td
                              className={`bg-gradient bg-black cp op ${
                                !item.Results ? "text-info" : ""
                              }`}
                              onClick={() =>
                                item.Results
                                  ? navigate(
                                      `/F1Race/${item.season}/${item.round}`
                                    )
                                  : navigate(
                                      `/Sprint/${item.season}/${
                                        item.round
                                      }/${new Date(item.date + " " + item.time)
                                        .toLocaleString("tr-TR", {
                                          dateStyle: "short",
                                          timeStyle: "short",
                                        })
                                        .replace(/,/g, "")}`
                                    )
                              }
                            >
                              <span className="">
                                <span className="text-decoration-underline">
                                  {item.Results
                                    ? item.raceName
                                    : item.raceName + " Sprint"}
                                </span>{" "}
                                <span className="fst-italic bg-black px-2">
                                  {getFormattedDate(item)}
                                </span>
                              </span>
                            </td>
                            <td
                              className={
                                "text-center text-info fw-bold " +
                                (results[0]
                                  ? isNaN(results[0]?.positionText)
                                    ? " text-danger"
                                    : null
                                  : null)
                              }
                            >
                              {/* {(() => {
                                const position = results[0]?.positionText; 
                                const positionDigits = position
                                  ? position.split("")
                                  : []; 

                                const isNumber = (value) => !isNaN(value);

                                return (
                                  <>
                                    {positionDigits.map((item, index) => {
                                      if (isNumber(item)) {
                                        return (
                                          <i
                                            key={index}
                                            className={`bi bi-${item}-square-fill fs-5`}
                                          />
                                        );
                                      }
                                      return results[0]?.positionText;
                                    })}
                                  </>
                                );
                              })()} */}
                              {isNaN(parseInt(results[0]?.positionText))
                                ? `${results[0]?.position} ${results[0]?.positionText}`
                                : results[0]?.positionText}
                            </td>

                            <td className="text-center text-secondary fw-bold op p-0">
                              {results.length > 0 ? results[0].grid : "-"}
                            </td>
                            <td className="text-center text-primary fw-bold op p-0">
                              {results.length > 0 ? results[0].laps : "-"}
                            </td>
                            <td className="text-end text-warning p-0 text-uppercase">
                              {results.length > 0 ? (
                                <span className="pe-1">
                                  {results[0]?.Time?.time
                                    ? results[0]?.Time?.time
                                    : "-"}
                                </span>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td className="text-center text-warning p-0 text-uppercase fw-bold">
                              {results.length > 0 ? (
                                <span
                                  className={
                                    results[0]?.status === "Finished"
                                      ? "text-success"
                                      : "text-danger"
                                  }
                                >
                                  {results[0]?.status}
                                </span>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td className="text-center op">
                              {results.length > 0 ? results[0].points : "-"}
                            </td>
                            <td className="text-danger text-end">
                              <span className="">
                                {results.length > 0 &&
                                results[0]?.FastestLap ? (
                                  <>
                                    <span className="">
                                      {results[0].FastestLap.rank
                                        ? results[0].FastestLap.rank + " ("
                                        : null}
                                    </span>
                                    {results[0].FastestLap.Time?.time + " "}
                                    {results[0].FastestLap.AverageSpeed
                                      ? "AvgSpd: " +
                                        results[0].FastestLap.AverageSpeed
                                          ?.speed +
                                        " " +
                                        results[0].FastestLap.AverageSpeed
                                          ?.units +
                                        "  "
                                      : null}
                                    Lap: {results[0].FastestLap.lap})
                                  </>
                                ) : (
                                  <span className="">-</span>
                                )}
                              </span>
                            </td>
                            <td
                              className="text-center text-uppercase cp"
                              onClick={() => {
                                navigate(
                                  "/ConstructorsResult/" +
                                    results[0]?.Constructor?.constructorId +
                                    "/" +
                                    item.season
                                );
                              }}
                            >
                              <span className="fw-bold text-center text-success">
                                {results.length > 0
                                  ? results[0]?.Constructor?.name
                                  : "-"}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    <tr>
                      <td
                        colSpan={11}
                        className="text-center text-light fw-bold"
                      >
                        Total Points:{" "}
                        {groupedData[season]
                          .reduce((totalPoints, item) => {
                            const results =
                              item.Results || item.SprintResults || [];
                            const points = results[0]?.points;

                            if (points !== undefined && points !== null) {
                              return totalPoints + parseFloat(points);
                            }
                            return totalPoints;
                          }, 0)
                          .toFixed(0)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
};

export default ResultsDriver;
